export const APIURL = "http://103.114.153.189:8075/salarytap";
export const APIURLCOT = "http://103.114.153.189:8074/cashontap";

// export const APIURL = "http://139.59.6.170:8080/salarytap";
